export const INVITE_PARTICIPANT = 'INVITE_PARTICIPANT';
export const INCOMING_REQUEST = 'INCOMING_REQUEST';
export const EXISTING_ORGANIZATION = 'EXISTING_ORGANIZATION';
